import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
  travelInsurance: { totalAmount : 0  },
  baggageInsurance: {addedAmount : 0 },
  refundInsurance: {addedAmount : 0 },
   coupon :  {
    appliedCodeAmount: 0,
    appliedCodeName: "",
    isDisable: false,
  },
  finalData : {},
  grandTotal: 0
};

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setInitialState(state, action) {
      // This allows resetting to a complete custom state if needed
      return action.payload; 
    },
    updateTravelInsurance(state, action) {
      state.travelInsurance = action.payload;
      console.log("action.payload",action.payload)
      state.grandTotal += (state?.travelInsurance?.totalAmount || 0) ;    
    },
    updateRefundInsurance(state, action) {
      state.refundInsurance = action.payload;
      console.log("action.payload",action.payload)
      state.grandTotal += (state?.refundInsurance?.addedAmount || 0) ;    
    },
    updateBaggageInsurance(state, action) {
      state.baggageInsurance = action.payload;
      state.grandTotal = state.travelInsurance + state.baggageInsurance;
    },
    removeAllInsurance(state, action) {
      state.travelInsurance = { totalAmount : 0  };
      state.baggageInsurance = {addedAmount : 0 };
      state.refundInsurance = {addedAmount : 0 };
      state.grandTotal = 0;
    },
    clearRefundInsurance(state) {
      state.refundInsurance = { addedAmount: 0 };
    },
    updateGrandTotal(state, action) {
      state.grandTotal = action.payload;
    },
    // Use this if you want to update multiple values at once
    updateCheckout(state, action) {
      const { travelInsurance, baggageInsurance , coupon } = action.payload;
      
      if (travelInsurance !== undefined) {
        state.travelInsurance = travelInsurance;
      }
      
      if (baggageInsurance !== undefined) {
        state.baggageInsurance = baggageInsurance;
      }
      
      if (coupon !== undefined) {
        state.coupon = coupon;
      }
      
      // Always recalculate the total
      state.grandTotal = state.travelInsurance + state.baggageInsurance;
    }
  },
});

export const { 
  setInitialState, 
  updateTravelInsurance, 
  updateBaggageInsurance, 
  updateRefundInsurance,
  updateGrandTotal,
  updateCheckout,
  clearRefundInsurance,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;